export default "__VITE_ASSET__LsKLCBb5__"